const defaultServiceFiscalState = () => ({
  fiscal: {
    tributes: null,
    ibpt: '',
    cnae: '',
    cstId: null,
    cstPisId: null,
    cstCofinsId: null,
    tributesId: null,
    motDesIcmsId: null,
    cst: null,
    cstPis: null,
    cstCofins: null,
    nbsId: null,
    nbs: null,
    motDesIcms: null,
    cofinsPercentage: 0,
    cofinsValue: 0,
    pisPercentage: 0,
    pisValue: 0,
    issPercentage: 0,
    issValue: 0,
    baseIssPercentage: 0,
    otherRetentionsValue: 0,
    deductionsValue: 0,
    deductionsJustification: '',
  },
});

export const defaultServiceState = () => ({
  id: undefined,
  description: '',
  price: 0,
  reference: '',
  unitOfMeasure: null,
  unitOfMeasureId: null,
  group: null,
  groupId: null,
  preferredSupplier: null,
  lastSellDate: null,
  observation: '',
  active: true,
  createdAt: null,
  ...defaultServiceFiscalState(),
});

const defaultModuleState = () => ({
  summaryServices: [],
  serviceCollection: [],
  paginationService: {
    perPage: 15,
    currentPage: 1,
  },
});

const initialState = {
  ...defaultModuleState(),
  service: {
    ...defaultServiceState(),
  },
  warnings: [],
};

export default {
  ...initialState,
};
